import './App.css';
import "bootstrap/dist/css/bootstrap.css";
import Weather from './Weather';

export default function App() {
  return (
    <div className="App">
      <Weather defaultCity="Buea"/>
      <footer>
        This project was coded by Suzy Kenne and it is {""}
        <a href='https://github.com/SuzyKenne/weather-react'>open-sourced</a>
      </footer>
    </div>
  );
}


